/* bb-collections.js — runtime helper for /collections/* clean URL family.
 *
 * Responsibilities:
 *   1. Sync the on-page H1 to the clean-URL-derived heading (set by
 *      bb-clean-url-head.liquid via <meta name="bb-clean-url-h1">).
 *   2. Cascade-up: if the filtered grid renders zero products on a clean
 *      URL, immediately replace the URL with its parent path (drop the
 *      deepest slug). Repeats until products appear OR we hit /collections/{cat}/.
 *   3. Strip _bb_path and filter.* query params from any internal /collections/*
 *      links the theme renders, so users navigating clicks stay on clean URLs.
 *
 * Dependencies (loaded into the DOM by the section that includes this file):
 *   - <meta name="bb-clean-url-path">      — full clean URL ("/collections/shirts/blue/")
 *   - <meta name="bb-clean-url-cat">       — category slug ("shirts")
 *   - <meta name="bb-clean-url-cat-label"> — category display label ("Shirts")
 *   - <meta name="bb-clean-url-h1">        — title without "| Basics Life" suffix
 *   - window.BBCollectionsData             — JSON loaded from bb-collections-data.json
 *
 * NOT a dependency: the Cloudflare Worker. When the Worker is offline (Phase
 * A development), this script is a no-op because the meta tags above are
 * never emitted (Liquid bails out without ?_bb_path). Page renders as a normal
 * Shopify-filtered collection — graceful fallback.
 */

(function () {
  'use strict';

  /* Bucket data — mirrors assets/bb-collections-data.json. Keep in sync when
     facet definitions change. Used by link-rewriting; not needed for H1 sync
     or cascade-up. */
  window.BBCollectionsData = {
    facetOrder: ['color', 'design', 'fabric', 'fit', 'style', 'neck'],
    tagPrefix:  { color: 'COLOUR', design: 'DESIGN', fabric: 'MATERIAL', fit: 'FIT', style: 'STYLE', neck: 'NECK' },
    facetBuckets: {
      color: [
        { slug:'black',  raws:['BLACK','DARK BLACK'] },
        { slug:'white',  raws:['WHITE','OFF WHITE','ECRU','HALF WHITE','NATURAL'] },
        { slug:'blue',   raws:['BLUE','LIGHT BLUE','MID BLUE','DARK BLUE','LIGHT NAVY'] },
        { slug:'navy',   raws:['NAVY','DARK NAVY'] },
        { slug:'green',  raws:['GREEN','LIGHT GREEN','MID GREEN','DARK GREEN'] },
        { slug:'olive',  raws:['OLIVE'] },
        { slug:'red',    raws:['RED','LIGHT RED'] },
        { slug:'maroon', raws:['MAROON','WINE','BRICK'] },
        { slug:'brown',  raws:['BROWN','MID BROWN','DARK BROWN','LIGHT BROWN','COFFEE','LIGHT COFFEE','TAN'] },
        { slug:'beige',  raws:['BEIGE','STONE'] },
        { slug:'khaki',  raws:['KHAKI','LIGHT KHAKI','MID KHAKI'] },
        { slug:'grey',   raws:['GREY','DARK GREY','MID GREY','LIGHT GREY','STEEL GREY'] },
        { slug:'pink',   raws:['PINK','LIGHT PINK','PEACH'] },
        { slug:'yellow', raws:['YELLOW','MUSTARD'] },
        { slug:'orange', raws:['ORANGE','LIGHT ORANGE'] },
        { slug:'purple', raws:['PURPLE','LILAC'] },
        { slug:'teal',   raws:['TEAL','AQUA','TURQUOISE'] }
      ],
      design: [
        { slug:'plain',   raws:['PLAIN','SELF'] },
        { slug:'checked', raws:['CHECKS'] },
        { slug:'striped', raws:['STRIPES'] },
        { slug:'printed', raws:['PRINT','TIE AND DYE','DIP DYE'] }
      ],
      fabric: [
        { slug:'cotton',    matchPattern:'COTTON' },
        { slug:'linen',     matchPattern:'LINEN' },
        { slug:'polyester', matchPattern:'POLY' },
        { slug:'viscose',   matchPattern:'VISCOSE' },
        { slug:'denim',     matchPattern:'DENIM' },
        { slug:'tencel',    matchPattern:'TENCEL' },
        { slug:'modal',     matchPattern:'MODAL' },
        { slug:'lyocell',   matchPattern:'LYOCELL' },
        { slug:'leather',   matchPattern:'LEATHER' }
      ],
      fit: [
        // 2026-05-26: brand-name fit slugs (was collapsed: 'slim' = SLIM|SKINNY|SUPER SKINNY|BLADE etc.).
        // Each catalog FIT value gets its own slug → its own URL (/jeans/torque/, /jeans/blade/, etc.).
        { slug:'slim',         raws:['SLIM'] },
        { slug:'skinny',       raws:['SKINNY'] },
        { slug:'super-skinny', raws:['SUPER SKINNY'] },
        { slug:'blade',        raws:['BLADE'] },
        { slug:'tapered',      raws:['TAPERED'] },
        { slug:'drift',        raws:['DRIFT'] },
        { slug:'torque',       raws:['TORQUE'] },
        { slug:'kerb',         raws:['KERB'] },
        { slug:'muscle',       raws:['MUSCLE'] },
        { slug:'relaxed',      raws:['RELAXED'] },
        { slug:'jogger',       raws:['JOGGER'] },
        { slug:'comfort',      raws:['COMFORT'] },
        { slug:'regular',      raws:['REGULAR'] }
      ],
      style: [
        { slug:'full-sleeve', raws:['LONGSLEEVES'] },
        { slug:'half-sleeve', raws:['HALFSLEEVES'] },
        { slug:'sleeveless',  raws:['SLEEVELESS'] },
        { slug:'flat-front',  raws:['FLATFRONT'] },
        { slug:'regular-cut', raws:['REGULAR'] }
      ],
      neck: [
        { slug:'crew-neck',    raws:['CREW NECK','CREW'] },
        { slug:'polo',         raws:['POLO','POLO NECK'] },
        { slug:'henley',       raws:['HENLEY'] },
        { slug:'v-neck',       raws:['V NECK'] },
        { slug:'mandarin',     raws:['MANDARIN','STAND UP'] },
        { slug:'button-down',  raws:['BUTTON DOWN'] },
        { slug:'mid-cut-away', raws:['MID CUT AWAY'] }
      ]
    }
  };

  function meta(name) {
    var el = document.querySelector('meta[name="' + name + '"]');
    return el ? el.getAttribute('content') : '';
  }

  var cleanPath = meta('bb-clean-url-path');
  if (!cleanPath) return;   // no Worker context — bail

  var cleanH1 = meta('bb-clean-url-h1');
  var cleanCat = meta('bb-clean-url-cat');

  /* ── 1. H1 sync ────────────────────────────────────────────────────────
     The dawn section's H1 says "Shirts" (collection.title). We want the
     SEO-strong long-tail heading e.g. "Men's Blue Checked Cotton Shirts". */
  function syncH1() {
    if (!cleanH1) return;
    var h1Candidates = [
      'h1.bcl-collection__title',
      '.bcl-collection h1',
      '#bcl-collection h1',
      'h1'
    ];
    for (var i = 0; i < h1Candidates.length; i++) {
      var h1 = document.querySelector(h1Candidates[i]);
      if (h1) {
        h1.textContent = cleanH1;
        return;
      }
    }
  }

  /* ── 2. Cascade-up: zero-result fallback ───────────────────────────────
     Detect zero products on the current page. Two signals:
       a. <body> contains a Shopify empty-state element
       b. Product card count in the grid === 0
     If empty AND we have at least one facet slug, drop the deepest slug
     and JS-replace location to the parent URL (preserving query string
     EXCEPT the _bb_path + filter.* params Cloudflare added).

     We stop at /collections/{cat}/ — categories always have products, so
     by definition this terminates. */
  function isEmptyGrid() {
    // dawn's empty state markers
    if (document.querySelector('.bcl-empty')) return true;
    if (document.querySelector('.bcl-filter-empty')) return true;
    // count product cards
    var cards = document.querySelectorAll('.bcl-grid .bcl-card, .bcl-grid > [data-product-id]');
    if (cards.length === 0) {
      // also check there's actually a grid container (else maybe we're on a non-grid page)
      if (document.querySelector('.bcl-grid')) return true;
    }
    return false;
  }

  function parentPath(path) {
    var trimmed = path.replace(/\/+$/, '');
    var segs = trimmed.split('/');
    if (segs.length <= 3) return null;   // already at /collections/{cat} or root
    segs.pop();
    return segs.join('/') + '/';
  }

  function cascadeIfEmpty() {
    if (!isEmptyGrid()) return;
    var parent = parentPath(cleanPath);
    if (!parent) return;          // already at category root
    // 2026-05-26 defensive guard: cascade must stay within the SAME category as
    // the current address-bar URL. If cleanPath has somehow been polluted to a
    // different category (e.g. meta tag from cache mismatch), refuse to redirect
    // — otherwise filtering shirts could end up on /jeans/ etc.
    var currCat = (location.pathname.match(/^\/collections\/([^\/]+)/) || [])[1];
    var parentCat = (parent.match(/^\/collections\/([^\/]+)/) || [])[1];
    if (currCat && parentCat && currCat !== parentCat) {
      console.warn('[bb-collections] cascade-up suppressed — category mismatch: location=' + currCat + ' cleanPath=' + parentCat);
      return;
    }
    // Preserve user query string (page, sort_by) but not the Cloudflare-injected stuff
    var keepParams = [];
    var params = new URLSearchParams(location.search);
    var DROP_PREFIXES = ['_bb_', 'filter.'];
    params.forEach(function (v, k) {
      var drop = false;
      for (var i = 0; i < DROP_PREFIXES.length; i++) {
        if (k.indexOf(DROP_PREFIXES[i]) === 0) { drop = true; break; }
      }
      if (!drop) keepParams.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });
    var qs = keepParams.length ? '?' + keepParams.join('&') : '';
    // Add a counter to prevent infinite loop if cascade-up itself empty
    var iter = parseInt(sessionStorage.getItem('bb_cascade_iter') || '0', 10);
    if (iter > 7) {
      console.warn('[bb-collections] cascade-up exceeded 7 hops, stopping');
      sessionStorage.removeItem('bb_cascade_iter');
      return;
    }
    sessionStorage.setItem('bb_cascade_iter', String(iter + 1));
    location.replace(parent + qs);
  }
  // Clear the cascade counter once we've successfully shown products
  if (!isEmptyGrid()) sessionStorage.removeItem('bb_cascade_iter');

  /* ── 3. Strip Cloudflare-injected params from internal /collections/* links ─
     Theme renders filter forms/links pointing to e.g.
       /collections/shirts?filter.p.tag=COLOUR%3ANAVY
     If a user clicks such a link they'd hit the Shopify-native URL directly,
     bypassing Cloudflare. Rewrite these to the clean URL equivalent so the
     URL family stays consistent for users. */
  function rewriteLinks() {
    if (!window.BBCollectionsData) return;   // need bucket data to rewrite
    var links = document.querySelectorAll('a[href*="filter.p.tag="]');
    links.forEach(function (a) {
      try {
        var u = new URL(a.href, location.origin);
        if (!/^\/collections\//.test(u.pathname)) return;
        var clean = cleanFromFilterUrl(u);
        if (clean) a.setAttribute('href', clean);
      } catch (e) { /* malformed url, skip */ }
    });
  }
  function cleanFromFilterUrl(u) {
    // u.pathname = /collections/{handle}
    var m = u.pathname.match(/^\/collections\/([^\/]+)\/?$/);
    if (!m) return null;
    var cat = m[1];
    // Read filter.p.tag values
    var tags = u.searchParams.getAll('filter.p.tag');
    if (!tags.length) return u.pathname + u.search;
    // Group tags by family using BBCollectionsData
    var families = window.BBCollectionsData.facetOrder || [];
    var byFamily = {};
    tags.forEach(function (t) {
      var idx = t.indexOf(':');
      if (idx < 0) return;
      var prefix = t.slice(0, idx);
      var value = t.slice(idx + 1);
      var family = null;
      for (var f in window.BBCollectionsData.tagPrefix) {
        if (window.BBCollectionsData.tagPrefix[f] === prefix) { family = f; break; }
      }
      if (!family) return;
      // Find which slug bucket this raw value lives in
      var buckets = (window.BBCollectionsData.facetBuckets[family]) || [];
      for (var i = 0; i < buckets.length; i++) {
        var b = buckets[i];
        if (b.raws && b.raws.indexOf(value) >= 0) { byFamily[family] = b.slug; break; }
        if (b.matchPattern && value.indexOf(b.matchPattern) >= 0) { byFamily[family] = b.slug; break; }
      }
    });
    // Build the clean path in facet order
    var path = '/collections/' + cat + '/';
    for (var i = 0; i < families.length; i++) {
      var f = families[i];
      if (byFamily[f]) path += byFamily[f] + '/';
    }
    // Preserve non-filter query params (page, sort_by)
    var keep = [];
    u.searchParams.forEach(function (v, k) {
      if (k !== 'filter.p.tag' && k.indexOf('filter.') !== 0 && k.indexOf('_bb_') !== 0) {
        keep.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
    });
    return path + (keep.length ? '?' + keep.join('&') : '');
  }

  /* ── Boot ──────────────────────────────────────────────────────────────
     Order matters: rewrite links first (avoids users clicking dirty URLs
     while we're still working), then sync H1, then check cascade-up. */
  function boot() {
    rewriteLinks();
    syncH1();
    cascadeIfEmpty();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
